<template>
  <input
    @input="inputValue"
    :value="modelValue"
    type="text"
    class="frm-text frm-size-l"
    :class="hasError ? 'error' : ''"
    :disabled="disabled"
    v-bind="$attrs"
  />
</template>
<script setup>
import { defineEmits, defineProps, watch } from "vue";
const props = defineProps({
  modelValue: {
    required: true,
    default: false,
  },
  disabled: {
    required: true,
    default: false,
  },
  hasError: {
    default: false,
  }
});
const emit = defineEmits(["update:modelValue"]);
const inputValue = (e) => {
  const value = e.target.value;
  emit("update:modelValue", value);
};
let backup = "";
watch(
  () => props.disabled,
  (val) => {
    if (val) {
      backup = props.modelValue;
      emit("update:modelValue", "");
    } else {
      emit("update:modelValue", backup);
    }
  }
);
</script>
